"use client";

import React from "react";
import { Twitter, Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
const socials = [{
  name: "Twitter",
  icon: Twitter,
  href: "#"
}, {
  name: "Instagram",
  icon: Instagram,
  href: "#"
}, {
  name: "LinkedIn",
  icon: Linkedin,
  href: "#"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        <div className="h-4 w-24 bg-muted animate-pulse rounded" />
        <div className="h-4 w-32 bg-muted animate-pulse rounded" />
        <div className="h-4 w-20 bg-muted animate-pulse rounded" />
      </div>;
  }
  return <ul className="space-y-3 flex flex-col">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-foreground transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark bg-background text-foreground py-16 px-6 md:px-12 text-sm tracking-widest font-default">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/moza_casa_logo_dark.png" alt="moza casa" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground leading-relaxed max-w-xs">
              Simplifying smart home management with Apple HomeKit technology for a simpler life.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-foreground">
              Explore
            </h3>
            <MenuProvider menu_id="42">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-foreground">
              Connect
            </h3>
            <ul className="space-y-3 flex flex-col">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <li key={social.name} data-index={i}>
                    <Link to={social.href} className="text-muted-foreground hover:text-foreground transition-colors duration-200 flex items-center gap-3 w-fit">
                      <Icon className="size-4" />
                      <span>{social.name}</span>
                    </Link>
                  </li>;
            })}
            </ul>
          </div>
        </div>

        {}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4 text-muted-foreground text-xs">
          <p>© 2026&nbsp;Moza Casa. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-foreground transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}